// Ui.js is responsible for handling user interface interactions

let hamburger, menu, logo;
let navLinks, overlays;
let isAnyOverlayOpen = false;
let currentSection = null;

console.log("UI.js loaded");

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOM loaded...");
  initElements();
  initNav();
  initKeyboardControls();

  // Check for hash in URL on page load (deep linking)
  handleDeepLinking();

  // Listen for hash changes
  window.addEventListener("hashchange", handleDeepLinking);
});

function initElements() {
  hamburger = document.getElementById("menu-toggle");
  menu = document.getElementById("nav-overlay");
  logo = document.querySelector(".logo");
  navLinks = document.querySelectorAll(".nav-list a");
  overlays = document.querySelectorAll(".c_overlay");
}

function initNav() {
  if (hamburger && menu) {
    hamburger.addEventListener("click", () => {

      // If any content overlay is open, close it
      if (isAnyOverlayOpen && currentSection) {
        closeOverlay();
        return;
      }

      // Otherwise toggle the navigation menu
      toggleMenu();
    });

    // Add click event listeners to nav links
    navLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent default to handle navigation manually
        const targetId = link.getAttribute("href").substring(1);
        showSection(targetId);
        toggleMenu(false); // Close the menu
      });
    });
  } else {
    console.warn("Menu toggle or nav overlay not found in the DOM.");
  }
}

function initKeyboardControls() {
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      // If any overlay is open, close it
      if (isAnyOverlayOpen) {
        closeOverlay();
      } else if (menu.classList.contains("active")) {
        toggleMenu(false);
      }
    }
  });
}

function toggleMenu(show = null) {
  // If show is null, toggle the current state
  // If show is true or false, set to that state
  const shouldShow = show !== null ? show : !menu.classList.contains("active");

  if (shouldShow) {
    hamburger.classList.add("active");
    menu.classList.add("active");
    menu.classList.remove("hidden");
  } else {
    // hamburger.classList.remove("active");
    if (!currentSection) {
      hamburger.classList.remove("active");
    }
    menu.classList.remove("active");
    menu.classList.add("hidden");
  }
}

function handleDeepLinking() {
  // Get the hash from the URL (excluding the # character)
  const hash = window.location.hash.substring(1);

  // If there's a hash, try to show that section
  if (hash) {
    showSection(hash);
  }
}

function showSection(sectionId) {
  // Hide all overlays first
  hideAllOverlays();

  // Update currentSection
  currentSection = sectionId;

  // Show the target section if it exists
  const targetSection = document.getElementById(sectionId);
  if (targetSection) {
    targetSection.classList.remove("hidden");
    isAnyOverlayOpen = true;

    // Update URL
    const currentUrl = window.location.pathname + window.location.search;
    history.pushState(null, "", currentUrl + "#" + sectionId);

    // Turn hamburger into X
    hamburger.classList.add("active");
  }
}

function closeOverlay() {
  hideAllOverlays();

  // Reset hamburger icon
  hamburger.classList.remove("active");

  // Remove hash from URL without page jump
  history.pushState(
    null,
    "",
    window.location.pathname + window.location.search
  );

  // Reset state
  currentSection = null;
  isAnyOverlayOpen = false;
}

function hideAllOverlays() {
  overlays.forEach((overlay) => {
    overlay.classList.add("hidden");
  });

  // Also hide navigation if it's open
  if (menu.classList.contains("active")) {
    menu.classList.remove("active");
    menu.classList.add("hidden");
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const isDocMode = params.get("state") === "doc";

  if (isDocMode) {
    const logo = document.querySelector(".logo");
    const menu = document.querySelector(".hamburger-menu");

    if (logo) logo.classList.add("center-logo");
    if (menu) menu.classList.add("hide-menu");
  }
});
